__turbopack_context__.v({
  "caret": "aEVqQq_caret",
  "checkbox": "aEVqQq_checkbox",
  "dropdown": "aEVqQq_dropdown",
  "emptyList": "aEVqQq_emptyList",
  "footer": "aEVqQq_footer",
  "footerBtn": "aEVqQq_footerBtn",
  "footerButtons": "aEVqQq_footerButtons",
  "footerHint": "aEVqQq_footerHint",
  "footerLink": "aEVqQq_footerLink",
  "inputBox": "aEVqQq_inputBox",
  "label": "aEVqQq_label",
  "listContainer": "aEVqQq_listContainer",
  "optionAvatar": "aEVqQq_optionAvatar",
  "optionLabel": "aEVqQq_optionLabel",
  "optionRow": "aEVqQq_optionRow",
  "placeholder": "aEVqQq_placeholder",
  "root": "aEVqQq_root",
  "searchIcon": "aEVqQq_searchIcon",
  "searchInput": "aEVqQq_searchInput",
  "searchRow": "aEVqQq_searchRow",
  "tag": "aEVqQq_tag",
  "tagAvatar": "aEVqQq_tagAvatar",
  "tagLabel": "aEVqQq_tagLabel",
  "tagRemove": "aEVqQq_tagRemove",
  "tags": "aEVqQq_tags",
});
